// How long the free trial is — from Superadmin → Trials, never typed into a page.
//
// ⚠️ The landing page said "Free for one month" as fixed text, so changing the trial length
// in Superadmin changed the sign-up page, the welcome email and the trial itself, but not
// the first thing a visitor reads (found 13/10/2026). The same public endpoint the sign-up
// page uses: GET /api/auth/signup-info. Same origin on the marketing host (marketingApiBase),
// so it works on holidayhive.co.uk as well as locally.
//
// null until it arrives — and a page that gets null says "Free trial" without a number,
// rather than guessing one. A moment's pop-in beats a moment's lie.
import { useEffect, useState } from 'react';
import { marketingApiBase } from './hosts';

export default function useTrialDays() {
  const [days, setDays] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetch(`${marketingApiBase()}/api/auth/signup-info`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const n = parseInt(d?.trial_period_days, 10);
        if (!cancelled && Number.isFinite(n) && n > 0) setDays(n);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return days;
}
